import Vue from 'vue'
import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import VueRouter from 'vue-router'
import { SET_LOGGED_IN, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },  
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/Login.vue')
  }, 
  {
    path: '/reset-password/',
    name: 'resetpassword',
    component: () => import('../views/Login/ResetPassword.vue')
  },  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard/Dashboard.vue'),  
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/Users/Users.vue'),   
  }, 
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import('../views/Inbox/Inbox.vue'),   
  },    
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/Equipments/Equipments.vue'),   
  },  
  {
    path: '/equipment/edit/:id',
    name: 'editequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),  
  },  
  {
    path: '/equipment/add',
    name: 'addequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),   
  },     
  {
    path: '/modules',
    name: 'modules',
    component: () => import('../views/Modules/Modules.vue'),   
  }, 
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Login/Register.vue'),   
  },   
  {
    path: '/groups',
    name: 'groups',
    component: () => import('../views/Groups/Groups.vue'),   
  },   
  {
    path: '/groups/edit/:id',
    name: 'editgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),  
  },  
  {
    path: '/groups/add',
    name: 'addgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),   
  },
  {
    path: '/learningmaterial',
    name: 'learningmaterial',
    component: () => import('../views/Documents/Documents.vue'),   
  },
  {
    path: '/courses',
    name: 'courses',
    component: () => import('../views/Courses/Courses.vue'),   
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings/Settings.vue'),   
  },
  {
    path: '/learningmaterial/:id',
    name: 'learningmaterialdetail',
    component: () => import('../views/Documents/DocumentDetail.vue'),   
  },  
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('../views/Users/Invoices.vue'),   
  }, 
  {
    path: '/forgot-password',
    name: 'forgotpassword',
    component: () => import('../views/Login/ForgotPassword.vue'),
  },     
  {
    path: '/users/edit/:id',
    name: 'editusers',
    component: () => import('../views/Users/addeditUsers.vue'),  
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Users/Profile.vue'),  
  },  
  {
    path: '/users/add',
    name: 'addusers',
    component: () => import('../views/Users/addeditUsers.vue'),   
  },      
  {
    path: '/modules/:id',
    name: 'moduledetails',
    component: () => import('../views/ModuleDetail/ModuleDetail.vue'),  
  }, 
  {
    path: '/moduleplayer/:id',
    name: 'moduleplayer',
    component: () => import('../views/ModulePlayer/ModulePlayer.vue'),  
  },  
  {
    path: '/pages/:slug',
    name: 'pages',
    component: () => import('../views/Pages/Pages.vue'),  
  },  
  {
    path: '/reminder',
    name: 'reminder',
    component: () => import('../views/ReminderEmail/ReminderEmail.vue'),  
  },  
  {
    path: '/reminder/add',
    name: 'addreminderemail',
    component: () => import('../views/ReminderEmail/addeditReminderEmail.vue'),   
  },   
  {
    path: '/reminder/edit/:id',
    name: 'editreminderemail',
    component: () => import('../views/ReminderEmail/addeditReminderEmail.vue'),   
  },   
  {
    path: '/equipment-group',
    name: 'equipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/EquipmentGroup.vue'),  
  },  
  {
    path: '/equipment-group/add',
    name: 'addequipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/addeditEquipmentGroup.vue'),  
  },  
  {
    path: '/equipment-group/edit/:id',
    name: 'editequipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/addeditEquipmentGroup.vue'),  
  }, 
  {
    path: '/equipment-template',
    name: 'Calibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/CalibrationTemplate.vue'),  
  },  
  {
    path: '/equipment-template/add',
    name: 'addCalibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/addeditCalibrationTemplate.vue'),  
  },  
  {
    path: '/equipment-template/edit/:id',
    name: 'editCalibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/addeditCalibrationTemplate.vue'),  
  }, 
  {
    path: '/personal-template',
    name: 'personaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/PersonalTemplate.vue'),  
  }, 
  {
    path: '/personal-template/add',
    name: 'addpersonaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/addeditPersonalTemplate.vue'),  
  }, 
  {
    path: '/personal-template/edit/:id',
    name: 'editpersonaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/addeditPersonalTemplate.vue'),  
  }, 
  {
    path: '/task-center-group',
    name: 'testcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/TestCaseGroup.vue'),  
  }, 
  {
    path: '/task-center-group/add',
    name: 'addtestcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/addeditTestCaseGroup.vue'),  
  }, 
  {
    path: '/task-center-group/edit/:id',
    name: 'edittestcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/addeditTestCaseGroup.vue'),  
  }, 
  {
    path: '/task-center-template',
    name: 'testcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/TestCaseTemplate.vue'),  
  },
  {
    path: '/task-center-template/add',
    name: 'addtestcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/addeditTestCaseTemplate.vue'),  
  }, 
  {
    path: '/task-center-template/edit/:id',
    name: 'edittestcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/addeditTestCaseTemplate.vue'),  
  }, 
  {
    path: '/task-center/',
    name: 'testcase',
    component: () => import('../views/TestCase/TestCase.vue'),  
  },   
  {
    path: '/task-center/add',
    name: 'testcaseadd',
    component: () => import('../views/TestCase/addeditTestCase.vue'),  
  }, 
  {
    path: '/task-center/edit/:id',
    name: 'testcaseedit',
    component: () => import('../views/TestCase/addeditTestCase.vue'),  
  },  

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
    if(store.getters.isAuthenticated){
      if (JwtService.getToken()) {
        ApiService.setHeader();
        store.commit(SET_ROUTER_ENTER, true)
        store.commit(SET_LOGGED_IN, true)
      }
    }
    if (!['login','forgotpassword','resetpassword','register'].includes(to.name) && !store.getters.isAuthenticated) next({ name: 'login' })
    else next()    


})



export default router
